// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mhTng","input":"styles_input__2IJ-0"};